import React, {useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {AppBar} from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import useTemplateInstance from "../../../hooks/useTemplateInstance";
import {usePriceList} from "../../../../Providers/PriceListProvider";
import {useRouteMatch} from "react-router";
import {Trans} from "react-i18next";
import ProductPriceInfoPopup from "../../../../Components/TemplateList/ProductPriceInfoPopup";

const useStyles = makeStyles((theme) => ({
    appBarRoot: {
        backgroundColor: 'white',
        color: 'black',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        minHeight: '56px',
    },
    titleContainer: {
        flexGrow: 1,
        marginLeft: '-48px',
        '& h2': {
            fontSize: '15px',
            marginTop: 0,
            marginBottom: 0,
            lineHeight: 1,
            textAlign: 'center'
        },
        '& h4': {
            fontSize: '12px',
            marginTop: 0,
            marginBottom: 0,
            fontWeight: 'normal',
            textAlign: 'center'
        }
    },
    priceCell: {
        textAlign: 'right'
    },
    prices: {
        textDecoration: 'underline'
    }
}));

export default ({onCancel}) => {
    const classes = useStyles();
    const [state] = useTemplateInstance();
    const {getPriceAsString} = usePriceList();
    const [showPriceInfo, setShowPriceInfo] = useState(false)
    const product = state.product;

    const priceAsString = getPriceAsString(product, state.template.categories);

    return (
        <React.Fragment>
            <AppBar classes={{root: classes.appBarRoot}} position='static' onClick={() => setShowPriceInfo(true)}>
                <div className={classes.toolbar}>
                    <IconButton onClick={onCancel}>
                        <Icon>arrow_back</Icon>
                    </IconButton>
                    <div className={classes.titleContainer}>
                        <h2>{product.name}</h2>
                        <h4>{priceAsString} {product.productprices.length > 1 && <span> (<span className={classes.prices}><Trans>Prices</Trans></span>)</span>}</h4>
                    </div>
                </div>
            </AppBar>
            <ProductPriceInfoPopup product={product} categories={state.template.categories} open={!!showPriceInfo} handleClose={() => setShowPriceInfo(false)} />
        </React.Fragment>
    )
}
